export default "__VITE_ASSET__97c29c12__"